<template>
  <section class="default-container">
    <BreadCrumb :bread-crumb="breadCrumb" />
    <div class="content">
      <div class="content-left">
        <div class="left-title">월간인사관리</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]" @click="menuClick(index)">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div
                v-for="(subMenu, idx) in menu.subMenu"
                :key="'subMenu' + idx"
                :class="['sub-menu__item', {on: subMenu.selected}]"
                @click="subMenuClick(index, idx)"
              >
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <Tab1 v-if="menuList[0].selected === true" :menu="menuList[0].subMenu.findIndex(item => item.selected)" />
        <Tab2 v-if="menuList[1].selected === true" :menu="menuList[1].subMenu.findIndex(item => item.selected)" />
        <Tab3 v-if="menuList[2].selected === true" :menu="menuList[2].subMenu.findIndex(item => item.selected)" />
        <Tab4 v-if="menuList[3].selected === true" :menu="menuList[3].subMenu.findIndex(item => item.selected)" />
        <Tab5 v-if="menuList[4].selected === true" :menu="menuList[4].subMenu.findIndex(item => item.selected)" />
      </div>
    </div>
  </section>
</template>

<script>
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import {useMagazineStore} from '~/store/magazine/index.js'
import Tab5 from '~/components/magazine/Tab5.vue'
import Tab3 from '~/components/magazine/Tab3.vue'
import Tab4 from '~/components/magazine/Tab4.vue'
import Tab2 from '~/components/magazine/Tab2.vue'
import Tab1 from '~/components/magazine/Tab1.vue'
import {useHead} from '#imports'

export default {
  name: 'MagazineIndex',
  components: {Tab1, Tab2, Tab4, Tab3, Tab5, BreadCrumb},
  setup() {
    const store = useMagazineStore()
    // 사이트 링크용 메타 태그 설정
    useHead({
      title: '월간인사관리 | 한국인사관리협회',
      meta: [
        {
          name: 'description',
          content: '한국인사관리협회 공식 HR 전문 매거진, 월간인사관리를 통해 최신 인사 트렌드, 전문 지식, 현장 사례를 만나보세요.'
        },
        {
          property: 'og:title', // Open Graph 태그 (카카오톡, 페이스북 등 공유 시 미리보기 제목)
          content: '월간인사관리 | 한국인사관리협회'
        },
        {
          property: 'og:description', // Open Graph 태그 (공유 시 미리보기 설명)
          content: '한국인사관리협회 공식 HR 전문 매거진, 월간인사관리를 통해 최신 인사 트렌드, 전문 지식, 현장 사례를 만나보세요.'
        }
      ],
      // 쿼리 파라미터가 붙더라도 항상 이 URL이 표준임을 알립니다.
      link: [
        { rel: 'canonical', href: 'https://insabank.com/magazine' }
      ]
    })
    return {store}
  },
  data() {
    return {
      breadCrumb: [],
      menuList: [
        {
          name: '월간인사관리 안내',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '월간인사관리 안내', selected: false}]
        },
        {
          name: '목차',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '전체보기', selected: false},
            {name: 'Feature', selected: false},
            {name: 'Department', selected: false},
            {name: 'P&O', selected: false}
          ]
        },
        {
          name: '월호보기',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '월호보기', selected: false}]
        },
        {
          name: '구독 신청',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '구독 신청', selected: false}]
        },
        {
          name: '월간인사관리 광고문의',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '월간인사관리 광고문의', selected: false}]
        }
      ]
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.menuController()
      },
      deep: true
    }
  },
  mounted() {
    this.menuController()
  },
  methods: {
    menuClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/magazine?menu=0&subMenu=0')
          break
        case 1:
          this.$router.push('/magazine?menu=1&subMenu=0')
          break
        case 2:
          this.$router.push('/magazine?menu=2&subMenu=0')
          break
        case 3:
          this.$router.push('/magazine?menu=3&subMenu=0')
          break
        case 4:
          this.$router.push('/magazine?menu=4&subMenu=0')
          break
      }

      window.scrollTo({top: 0})
    },
    subMenuClick(index, idx) {
      this.$router.push(`/magazine?menu=${index}&subMenu=${idx}`)

      window.scrollTo({top: 0})
    },
    menuController() {
      const urlParams = new URLSearchParams(window.location.search)
      const menuIndex = parseInt(urlParams.get('menu') || '0')
      const subMenuIndex = parseInt(urlParams.get('subMenu') || '0')

      // 기존 메뉴 서브메뉴는 초기화
      this.menuList.forEach(menu => {
        menu.selected = false
        menu.subMenuShow = false
        if (menu.subMenu) {
          menu.subMenu.forEach(subMenu => {
            subMenu.selected = false
          })
        }
      })

      // 선택된 메뉴와 서브메뉴의 상태 변경
      if (this.menuList[menuIndex]) {
        this.menuList[menuIndex].selected = true
        this.menuList[menuIndex].subMenuShow = true

        if (this.menuList[menuIndex].subMenu[subMenuIndex]) {
          this.menuList[menuIndex].subMenu[subMenuIndex].selected = true
        }
      }

      this.breadCrumbController(this.menuList[menuIndex].subMenu)
    },
    breadCrumbController(item) {
      // 초기화
      this.breadCrumb = []

      // 기본 breadcrumb 설정
      this.breadCrumb = ['홈', '월간인사관리']

      this.menuList.forEach(menu => {
        if (menu.selected) {
          this.breadCrumb.push(menu.name)
          if (menu.subMenu) {
            menu.subMenu.forEach(subMenu => {
              if (subMenu.selected) {
                this.breadCrumb.push(subMenu.name)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.default-container {
  padding: 48px 0 100px;
  .content {
    display: flex;
    gap: 24px;
    position: relative;
    .content-left {
      min-width: 222px;
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;
      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }
      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;
        &:hover {
          color: #0058aa;
        }
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }
      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }
        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }
    .content-right {
      width: 100%;
      .book-list {
        .book-item {
          cursor: pointer;
          padding: 24px;
          display: flex;
          gap: 16px;
          border-bottom: 1px solid #dbdbdb;

          .book-img {
            width: 142.427px;
            height: 210px;
          }
          .book-item__right {
            .book-title {
              margin-bottom: 12px;
            }
            .is-14r {
              color: #909090;
              margin-bottom: 4px;
              strong {
                color: #121212;
              }
            }
          }
        }
      }
    }
  }
}
</style>
